import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';

function ConsultationsTable() {
  return (
    <div className='tableContainer'>
      <Table>
        <Thead>
          <Tr>
            <Th>Date</Th>
            <Th>Heure</Th>
            <Th>EXPERT</Th>
            <Th>DURÉE</Th>
            <Th>PRIX</Th>
            <Th>TYPE</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td className="color-red">13/03/2023</Td>
            <Td>12:03:56</Td>
            <Td className="color-green">Text</Td>
            <Td>0:19:59</Td>
            <Td>100 $</Td>
            <Td className="color-purple">Text</Td>
          </Tr>
          <Tr>
            <Td className="color-red">13/03/2023</Td>
            <Td>12:03:56</Td>
            <Td className="color-green">Text</Td>
            <Td>0:19:59</Td>
            <Td>100 $</Td>
            <Td className="color-purple">Text</Td>
          </Tr>
          <Tr>
            <Td className="color-red">13/03/2023</Td>
            <Td>12:03:56</Td>
            <Td className="color-green">Text</Td>
            <Td>0:19:59</Td>
            <Td>100 $</Td>
            <Td className="color-purple">Text</Td>
          </Tr>
          <Tr>
            <Td className="color-red">13/03/2023</Td>
            <Td>12:03:56</Td>
            <Td className="color-green">Text</Td>
            <Td>0:19:59</Td>
            <Td>100 $</Td>
            <Td className="color-purple">Text</Td>
          </Tr>
          <Tr>
            <Td className="color-red">13/03/2023</Td>
            <Td>12:03:56</Td>
            <Td className="color-green">Text</Td>
            <Td>0:19:59</Td>
            <Td>100 $</Td>
            <Td className="color-purple">Text</Td>
          </Tr>
        </Tbody>
      </Table>
    </div>
  );
}

export default ConsultationsTable;